import { stationKey, type Station } from "../lib/m3u";
import { useStarred } from "../lib/StarredContext";
import { usePlayer } from "../player/PlayerContext";
import StationLogo from "./StationLogo";

export default function StationRow({ station }: { station: Station }) {
  const player = usePlayer();
  const { isStarred, toggleStar } = useStarred();
  const isCurrent = player.station !== null && stationKey(player.station) === stationKey(station);
  const starred = isStarred(station);

  return (
    <li className={`flex items-center ${isCurrent ? "bg-sky-50" : ""}`}>
      <button
        type="button"
        onClick={() => player.play(station)}
        aria-current={isCurrent}
        className="flex min-w-0 flex-1 items-center gap-4 py-3 pl-4 text-left hover:bg-slate-50"
      >
        <StationLogo station={station} className="size-12 text-lg" />
        <div className="min-w-0 flex-1">
          <p className={`truncate font-medium ${isCurrent ? "text-sky-800" : "text-slate-900"}`}>{station.name}</p>
          <div className="mt-1 flex flex-wrap gap-1">
            {station.genres.map((genre) => (
              <span key={genre} className="rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-600">
                {genre}
              </span>
            ))}
          </div>
          <p className="mt-1 truncate text-xs text-slate-500">{station.url}</p>
        </div>
        <span aria-hidden className={`text-xl ${isCurrent ? "text-sky-600" : "text-slate-300"}`}>
          {isCurrent ? "♪" : "▶"}
        </span>
      </button>
      <button
        type="button"
        onClick={() => toggleStar(station)}
        aria-pressed={starred}
        aria-label={starred ? `Unstar ${station.name}` : `Star ${station.name}`}
        className={`self-stretch px-4 text-2xl hover:bg-slate-50 ${starred ? "text-amber-500" : "text-slate-300 hover:text-amber-400"}`}
      >
        {starred ? "★" : "☆"}
      </button>
    </li>
  );
}
